import type { LinkProps } from '@shopify/polaris';

import { Link } from '@shopify/polaris';
import { cls } from '~/utils';

export interface GTextLinkProps {
  children: React.ReactNode;
  linkAction?: LinkProps;
  isDisabled?: boolean;
  disabledFocus?: boolean;
  // Keep the link color (blue) even inside a Banner, which forces Polaris links to monochrome
  keepColor?: boolean;
}

export const GTextLink = ({
  linkAction,
  isDisabled,
  disabledFocus,
  keepColor,
  ...props
}: GTextLinkProps) => {
  const textLinkMarkup =
    linkAction && !isDisabled ? (
      <span
        className={cls('GTextLink', {
          'GTextLink--disabled-focus': disabledFocus,
          'GTextLink--keep-color': keepColor,
        })}
      >
        <Link {...linkAction}>
          <>{props.children}</>
        </Link>
      </span>
    ) : (
      <>{props.children}</>
    );

  return textLinkMarkup;
};
